export const SpaceInfoModel = Symbol.for('SpaceInfoModel');
